<template>
  <div :class="userLevelClass">
    <div
      :class="[
        {
          'yxtbiz-user-medal__flex-start d-in-block pull-left':
            levelMode === 'row'
        },
        { 'yxtbiz-user-medal__flex-center': levelMode !== 'row' }
      ]"
      v-if="!userLevel"
    >
      <div :class="medalClass" @click="onClick" v-if="count > -1">
        <yxtf-svg
          width="14px"
          height="16px"
          icon-class="medal-biz"
          :remote-url="mediaPath"
        />
        <span class="ml3">{{ formatCount() }}</span
        ><span class="ml2">{{ medalString }}</span>
      </div>
      <div :class="levelIconClass" v-if="levelNum > -1" @click="onLevelClick">
        <span>Lv.{{ levelNum }}</span>
      </div>
    </div>
    <div
      :class="levelTextClass"
      v-if="!userLevel && levelNum > -1 && isSelf"
      @click="onLevelClick"
    >
      {{ levelExpString }} <span class="yxt-weight-6">{{ exp }}</span
      >/{{ maxExp }}
    </div>
    <user-medal-info ref="medal" v-if="!userLevel" />
    <span v-if="userLevel && Number(userLevel) > -1">Lv.{{ userLevel }}</span>
  </div>
</template>

<script>
import userMedalInfo from './components/userMedalInfo';
import { getUserMedalCount, getUserLevel } from './service';

export default {
  name: 'YxtbizUserMedalTag',
  components: {
    userMedalInfo
  },
  props: {
    type: {
      // 点击勋章，是1跳转还是0出弹窗
      type: Number,
      default: 0
    },
    targetUrl: {
      // 点击勋章，跳转Url
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    orgId: {
      type: String,
      default: ''
    },
    userLogoUrl: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    isSelf: {
      // 是否本人查看
      type: Boolean,
      default: true
    },
    userLevel: {
      // 仅列表接入等级时传递
      type: String,
      default: ''
    },
    levelMode: {
      // 经验值模式
      type: String,
      validator(value) {
        return ['row', 'column', 'only'].includes(value);
      },
      default: 'only'
    },
    expTargetUrl: {
      // 点击等级经验，跳转Url
      type: String,
      default: ''
    }
  },
  data() {
    return {
      count: -1,
      levelNum: -1,
      exp: 0,
      maxExp: 0,
      medalString: this.$t('pc_biz_medal_lbl_medalcount'),
      levelExpString: this.$t('pc_biz_medal_lbl_levelexp'),
      mediaPath: `${this.$staticBaseUrl}ufd/407a24/reward/pc/svg`
    };
  },
  computed: {
    medalClass() {
      if (this.levelMode === 'column') {
        return 'yxtbiz-user-medal-tag-wrap hand mr16 pull-left';
      } else if (this.levelMode === 'row') {
        return 'yxtbiz-user-medal-tag-wrap hand mr16 pull-left';
      }
    },
    levelIconClass() {
      if (this.levelMode === 'column') {
        return `yxtbiz-user-level-tag-wrap hand pull-left color-level-${this.getLevelNumClass()}`;
      } else if (this.levelMode === 'row') {
        return `yxtbiz-user-level-tag-wrap hand pull-left mr8 color-level-${this.getLevelNumClass()}`;
      }
    },
    levelTextClass() {
      if (this.levelMode === 'column') {
        return 'yxtbiz-user-level-text yxtbiz-user-level-process_gray hand mt8';
      } else if (this.levelMode === 'row') {
        return 'yxtbiz-user-level-text yxtbiz-user-level-process_white hand d-in-block pull-left';
      }
    },
    userLevelClass() {
      if (this.userLevel) {
        if (this.userLevel === '-1') {
          return 'd-none';
        }
        return `yxtbiz-user-level-tag-only color-level-${this.getLevelNumClass()}`;
      } else {
        return this.levelMode === 'row' ? 'yxtbiz-user-medal__flex-start' : '';
      }
    }
  },
  created() {
    !this.userLevel && this.getUserMedalCountData();
    !this.userLevel && this.getUserLevelData();
  },
  methods: {
    getLevelNumClass() {
      let number = Number(this.userLevel || this.levelNum);
      if (number < 5) {
        number = 1;
      } else if (number < 9) {
        number = 2;
      } else if (number < 13) {
        number = 3;
      } else if (number < 17) {
        number = 4;
      } else {
        number = 5;
      }
      return number;
    },
    getUserMedalCountData() {
      getUserMedalCount(this.orgId, this.userId)
        .then(res => {
          this.count = res.medalNum;
        })
        .catch(() => {});
    },
    getUserLevelData() {
      getUserLevel({ orgId: this.orgId, userId: this.userId })
        .then(res => {
          this.levelNum = res.level;
          this.exp = res.exp;
          this.maxExp = res.maxLevelExp;
        })
        .catch(() => {});
    },
    formatCount() {
      return this.count > 99 ? '99+' : this.count;
    },
    onClick() {
      if (this.type) {
        // location.href = this.targetUrl ? this.targetUrl : location.origin + '/reward/#/medalwall';
        window.open(
          this.targetUrl
            ? this.targetUrl
            : location.origin + '/reward/#/medalwall'
        );
      } else {
        this.count > 0 &&
          this.$refs.medal.show(
            this.orgId,
            this.userId,
            this.userLogoUrl,
            this.userName,
            this.count,
            this.isSelf
          );
      }
    },
    onLevelClick() {
      if (!this.isSelf) return;
      // location.href = this.expTargetUrl ? this.expTargetUrl : location.origin + '/reward/#/myexpdetail';
      window.open(
        this.expTargetUrl
          ? this.expTargetUrl
          : location.origin + '/reward/#/myexpdetail'
      );
    }
  }
};
</script>
